const imageModules = import.meta.glob("../../../assets/**/*", {
	eager: true,
	query: "?url",
	import: "default",
}) as Record<string, string>;

function getImageUrl(name: string): string {
	return imageModules[`../../../assets/${name}`] ?? "";
}

interface IImage {
	name: string;
	className?: string;
	onClick?: () => void;
}

const ImageViewer = ({ name, className, onClick, ...rest }: IImage) => {
	return <img className={className} src={getImageUrl(name)} alt={name} onClick={onClick} {...rest} />;
};

export default ImageViewer;
